import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["className", "color", "aria-label"],
  _excluded2 = ["backdropClassName", "className", "backdrop", "color", "aria-label"],
  _excluded3 = ["type", "isLoading", "thickness", "size", "valueBuffer"];
import React from 'react';
import PropTypes from 'prop-types';
import { CircularProgress as MuiCircularProgress, LinearProgress as MuiLinearProgress } from '@mui/material';
import useStyles from './Loading.styles';
var LinearLoading = function LinearLoading(props) {
  var className = props.className,
    color = props.color,
    _props$ariaLabel = props['aria-label'],
    ariaLabel = _props$ariaLabel === void 0 ? 'loading-linear' : _props$ariaLabel,
    other = _objectWithoutProperties(props, _excluded);
  var _useStyles = useStyles(),
    classes = _useStyles.classes,
    cx = _useStyles.cx;
  return /*#__PURE__*/React.createElement(MuiLinearProgress, _extends({
    className: cx(classes.linear, _defineProperty({}, classes.linearPrimary, color === 'primary'), _defineProperty({}, classes.linearSecondary, color === 'secondary'), className),
    "aria-label": ariaLabel
  }, other));
};
var CircularLoading = function CircularLoading(props) {
  var backdropClassName = props.backdropClassName,
    className = props.className,
    backdrop = props.backdrop,
    color = props.color,
    _props$ariaLabel2 = props['aria-label'],
    ariaLabel = _props$ariaLabel2 === void 0 ? 'loading-circle' : _props$ariaLabel2,
    other = _objectWithoutProperties(props, _excluded2);
  var _useStyles2 = useStyles(),
    classes = _useStyles2.classes,
    cx = _useStyles2.cx;
  var Component = function Component() {
    var _cx3;
    return /*#__PURE__*/React.createElement("div", {
      className: cx(classes.root, className),
      "aria-label": ariaLabel
    }, /*#__PURE__*/React.createElement(MuiCircularProgress, _extends({
      className: cx(classes.loading, (_cx3 = {}, _defineProperty(_cx3, classes.circularPrimary, color === 'primary'), _defineProperty(_cx3, classes.circularSecondary, color === 'secondary'), _defineProperty(_cx3, classes.circularTertiary, color === 'tertiary'), _cx3))
    }, other)));
  };
  return backdrop ? /*#__PURE__*/React.createElement("div", {
    className: cx(classes.backdrop, backdropClassName)
  }, /*#__PURE__*/React.createElement(Component, null)) : /*#__PURE__*/React.createElement(Component, null);
};
var Loading = function Loading(props) {
  var type = props.type,
    isLoading = props.isLoading,
    thickness = props.thickness,
    size = props.size,
    valueBuffer = props.valueBuffer,
    other = _objectWithoutProperties(props, _excluded3);
  if (!isLoading) {
    return null;
  } else if (type === 'linear') {
    return /*#__PURE__*/React.createElement(LinearLoading, _extends({
      valueBuffer: valueBuffer
    }, other));
  } else {
    return /*#__PURE__*/React.createElement(CircularLoading, _extends({
      thickness: thickness,
      size: size
    }, other));
  }
};
process.env.NODE_ENV !== "production" ? Loading.propTypes = {
  backdrop: PropTypes.bool,
  className: PropTypes.string,
  color: PropTypes.oneOf(['primary', 'secondary', 'tertiary']),
  variant: PropTypes.oneOf(['buffer',
  // only linear
  'determinate', 'indeterminate']),
  type: PropTypes.oneOf(['circular', 'linear']),
  isLoading: PropTypes.bool,
  thickness: PropTypes.number,
  // only circular
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  // only circular
  value: PropTypes.number,
  valueBuffer: PropTypes.number // only linear
} : void 0;
Loading.defaultProps = {
  color: 'primary',
  type: 'circular',
  isLoading: true,
  variant: 'indeterminate',
  thickness: 6,
  size: 20
};
export default Loading;